
<template>
  <div>
    <van-nav-bar :fixed="true" left-arrow @click-left="$router.back()">
      <template slot="title">
        <span class="title" v-if="groupid.length != 0">【组】</span>
        <span class="title">客户现场确认</span>
      </template>
    </van-nav-bar>
    <div class="top"></div>

    <div class="search" v-if="searchok == false">
      <form action="/">
        <van-search
          v-model="searchstr"
          show-action
          label=""
          placeholder="请输入客户电话"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch" class="btn">搜索</div>
          </template>
        </van-search>
      </form>
      <div class="userinfo" v-if="userInfo.客户姓名">
        <div >
        <div>
          客户姓名：<span> {{ userInfo.客户姓名 }}</span>
        </div>
        <div>
          推介来源：<span>{{ userInfo.推介来源 }}</span>
        </div>

        <div>
          跟办顾问：<span>{{ curSale }}</span>
        </div>

        <div v-if="userInfo.渠道公司">
          渠道公司：<span>{{ userInfo.渠道公司 }}</span>
        </div>
         <div v-if="userInfo.状态 != '未确认'" >
          当前状态：<span>{{ userInfo.状态 }}</span>
        </div>

<!-- v-if="userInfo.状态 != '未确认'" -->
        
        <!-- <div>
          客户电话：<span>{{ userInfo.tel }}</span>
        </div> -->
        <!-- <div>
          置业顾问：<span>{{ userInfo.tel }}</span>
        </div>
        <div>
          到访次数：<span>{{ userInfo.tel }}</span>
        </div>
         -->
        <div style="margin: 16px">
          <van-row>
            <van-col span="12">
              <van-button round block @click.prevent="Cancel">取消</van-button>
            </van-col>
            <van-col span="12">

              <van-button round block type="info" @click="onConform" :disabled="userInfo.状态 == '超出保护期' || userInfo.状态 == '锁定期'"
                >确认到访</van-button
              >
            </van-col>
          </van-row>
        </div>
      </div>
       
      </div>
     

    </div>
    <div class="form" v-else>
      <van-form @submit="onSubmit" name="userinfo" ref="userinfo">
        <van-field
          v-model="userInfo.所属项目"
          label="当前项目"
          readonly
          required
          placeholder="请选择当前项目"
        />
        <van-field
          v-model="userInfo.客户姓名"
          label="客户姓名"
          required
          placeholder="请输入姓名"
        />
        <van-field
          v-model="userInfo.推介来源"
          readonly
          required
          clickable
          label="推介来源"
          placeholder="推介来源"
          :rules="[rule_required]"
          @click="ShowPopub('推介来源')"
        />
        <van-field
          v-model="userInfo.其它推介来源"
          label="其它推介来源"
          required
          :rules="[rule_required]"
          placeholder="请输入其它推介来源"
          v-if="userInfo.推介来源 == '其他'"
        />

        <van-field
          v-model="userInfo.到访人数"
          readonly
          required
          clickable
          label="到访人数"
          placeholder="到访人数"
          :rules="[rule_required]"
          @click="ShowPopub('到访人数')"
        />

        <van-field
          v-model="userInfo.到访次数"
          readonly
          required
          clickable
          label="到访次数"
          placeholder="到访次数"
          :rules="[rule_required]"
          @click="ShowPopub('到访次数')"
        />
        <van-field
          v-model="userInfo.到访目的"
          readonly
          required
          clickable
          label="到访目的"
          placeholder="到访目的"
          :rules="[rule_required]"
          @click="ShowPopub('到访目的')"
        />
        <van-field
          v-model="userInfo.其它到访目的"
          label="其它到访目的"
          required
          :rules="[rule_required]"
          placeholder="请输入到访目的"
          v-if="userInfo.到访目的 == '其他'"
        />

        <van-field
          v-model="curSale"
          readonly
          label="跟办顾问"
          required
          :rules="[rule_required]"
          placeholder="跟办顾问"
          @click="selectSale"
        />
        <van-field v-model="userInfo.备注" label="备注" placeholder="备注" />
      </van-form>
      <div style="margin: 16px">
        <van-row>
          <van-col span="12">
            <van-button round block @click.prevent="Cancel">取消</van-button>
          </van-col>
          <van-col span="12">
            <van-button round block type="info" @click="Save">提交</van-button>
          </van-col>
        </van-row>
      </div>
    </div>

    <van-popup v-model="showPopup" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="popupList"
        @cancel="showPopup = false"
        @confirm="onPopupConfirm"
      />
    </van-popup>
    <van-popup
      v-model="popupPerson"
      position="top"
      @cancel="popupPerson = false"
      close-icon-position="top-left"
    >
      <div class="personlist">
        <div
          class="person"
          v-for="(p, i) in SalesList"
          :key="i"
          @click="onSelectSale(p)"
        >
          <!-- <img class="avatar" :src="p.avatarUrl" /> -->

          <div>
            {{ p["姓名"] }} <span>{{ p["系统账号"] }}</span>
          </div>
          <!-- <div>{{ p["手机号"] }}</div> -->
        </div>
      </div>
      <div class="popnavi">
        选择置业顾问
        <span class="button" @click="closeSaleSelect">取消</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "visit",
  components: {},
  props: {},

  data() {
    return {
      groupid: "",
      searchok: false,
      searchstr: "",
      popupPerson: false,
      curSale: "",
      SalesList: [],
      userInfo: {},
      showPopup: false,
      popupList: [],
      popubName: "",
      推介来源: [
        "全民营销",
        "渠道推荐",
        "中介推荐",
        "前台电话",
        "自然来访",
        "顾问约访",
        "电转访",
        "拓转访",
        "其他",
      ],
      到访次数: ["首次到访", "二次到访", "三次及以上"],
      到访目的: ["参与活动", "踩盘", "看房", "办理签约等业务", "其他"],
      到访人数: ["1", "2", "3", "4", "5", "6"],
    };
  },

  methods: {
    onSearch() {
      var check =
        /^(0|86|17951)?(13[0-9]|15[012356789]|16[0-9]|19[0-9]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/.test(
          this.searchstr
        );

      if (!check) {
        this.$toast({
          message: "请输入正确的电话号码",
        });
        return;
      }

      // let req = {
      //   table_name: "QMXY_visit",
      //   req: { tel: this.searchstr },
      // };
      this.curSale = "";
      this.userInfo = {};
      this.$request
        .customerByTel({
          tel: this.searchstr,
          project: localStorage.getItem("projectname"),
        })
        .then((res) => {
          if (res.code == 0) {
            this.userInfo = res.data;
            var overtime = 1000 * 3600 * 24 * 30;
            if (
              this.userInfo.状态 == "未确认" &&
              this.userInfo["推介来源"] == "渠道推荐"
            ) {
              var diff = new Date().getTime() - this.userInfo._createtime;
              console.log("diff",diff,overtime,diff<1000 * 60 * 30)
              if (diff > overtime) {
                 this.userInfo.状态 = "超出保护期"
              } else if (diff < 1000 * 60 * 30) {
                this.userInfo.状态 = "锁定期"
              }
              //this.userInfo.状态=(diff-1000 * 60 * 30)
            }

           
              //
              // this.userInfo["所属项目"] = localStorage.getItem("projectname");

              var buff = "";
            if (this.userInfo.跟办顾问) {
              buff = this.userInfo.跟办顾问; //默认为业绩人
            } else if (this.userInfo.推广业绩) {
              buff = this.userInfo.推广业绩; //默认为业绩人
            }

            //如果有顾问则需要显示出来
            if (buff != "") {
              for (var i in this.SalesList) {
                if (buff == this.SalesList[i].系统账号) {
                  this.onSelectSale(this.SalesList[i]);
                  // this.跟办顾问 = this.SalesList[i];
                  // this.userInfo["跟办顾问"] = 跟办顾问;
                  // this.userInfo["跟办顾问姓名"] = this.SalesList[i].姓名;
                }
              }
            }
          } else {
            this.$toast({
              message: "电话号码未登记",
            });
          }
        });
    },
    onConform() {
      this.searchok = true;
    },
    Save() {
      this.$refs["userinfo"].submit();
    },
    Cancel() {
      this.searchstr = "";
      this.searchok = false;
      this.userInfo = {};
    },
    onSubmit() {
      if (this.groupid.length > 0) this.userInfo.groupid = this.groupid;
      this.$request.customerVisit(this.userInfo).then((res) => {
        if (res.code == 0) {
          this.$toast({
            message: "确认成功！",
          });
          this.searchstr = "";
          this.searchok = false;
          this.userInfo = {};
        }
      });
    },
    closeSaleSelect() {
      console.log("closeSaleSelect");
      this.popupPerson = false;
    },

    getSalesList() {
      let req = {
        table_name: "sales团队",
        req: { 项目名称: localStorage.getItem("projectname") },
      };

      this.$request.dbreq(req).then((res) => {
        this.SalesList = [];
        for (var i in res.data.items) {
          for (var j in res.data.items[i]["成员列表"]) {
            var avatarid = res.data.items[i]["成员列表"][j].avatar;
            if (avatarid == undefined || avatarid == "")
              avatarid = "3ca00ce5-d861-48af-842a-68f0ac261ba2";
            res.data.items[i]["成员列表"][j].avatarUrl =
              this.$imgserver + "/avatar/img?id=" + avatarid;
            this.SalesList.push(res.data.items[i]["成员列表"][j]);
          }
        }
      });
    },
    selectSale() {
      if (this.curSale == "") {
        this.popupPerson = true;
      }
    },
    onSelectSale(sale) {
      this.curSale = sale["姓名"] + "[" + sale["系统账号"] + "]";
      this.userInfo["跟办顾问"] = sale["系统账号"];
      this.userInfo["跟办顾问姓名"] = sale.姓名;
      console.log(this.userInfo);
      this.popupPerson = false;
    },
    ShowPopub(name) {
      this.popubName = name;
      this.popupList = this[name];
      this.showPopup = true;
    },
    onPopupConfirm(value) {
      this.userInfo[this.popubName] = value;
      this.showPopup = false;
    },
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    // Generate a pseudo-GUID by concatenating random hexadecimal.
    Guid() {
      return (
        this.S4() +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        "-" +
        this.S4() +
        this.S4() +
        this.S4()
      );
    },
  },
  mounted() {
    this.getSalesList();
    var isgroup = this.$route.params.isgroup;
    console.log("isgroup", isgroup);
    if (isgroup == "group") this.groupid = this.Guid();
    else this.groupid = "";
  },
};
</script>
<style  lang="less" scoped>
.top {
  margin-top: 50px;
}
.btn {
  border: 1px solid gray;
  border-radius: 5px;
  padding: 0 10px;
}
.search {
  margin: 12px;
}
.userinfo {
  font-size: 14px;
  margin: 5px 20px;
  color: gray;
  span {
    color: lightskyblue;
  }
}

.personlist {
  overflow: scroll;
  height: calc(50vh);
}
.person {
  font-size: 12px;
  height: 130rpx;
  font-size: 24rpx;
  margin: 6px 10px;
  padding: 3px 10px;

  // width: 150rpx;
  border: solid 1px gray;
  // display: inline-block;
  span {
    float: right;
  }
}
.popnavi {
  border: 1px solid lightgray;
  line-height: 50px;
  font-size: 20px;
  padding: 0;
  text-align: center;
  .button {
    margin: 0;
    font-size: 16px;
    border-left: solid 1rpx lightgray;
    display: inline-block;
    width: 80px;
    text-align: center;
    line-height: 50px;
    float: right;
  }
}
</style>